import React from 'react';
import './membership.css';
import { useAuth } from '../AuthContext';

const Membership = () => {
    const { loggedIn, userID, userName, userAvatar, logout } = useAuth();
    
    // Live Stripe links
    const premiumStripeLink = "https://buy.stripe.com/aEUeYJ1jX8ba7oQ8wx";
    const premiumStripeLinkWithUser = `https://buy.stripe.com/aEUeYJ1jX8ba7oQ8wx?client_reference_id=${encodeURIComponent(userID)}`;


    const basicStripeLink = "https://buy.stripe.com/dR6bMx0fT3UU6kMfYY";
    const basicStripeLinkWithUser = `https://buy.stripe.com/dR6bMx0fT3UU6kMfYY?client_reference_id=${encodeURIComponent(userID)}`;

    const serverStripeLink = "https://buy.stripe.com/aEUaItd2F2QQ10saEG";
    const serverStripeLinkWithUser = `https://buy.stripe.com/aEUaItd2F2QQ10saEG?client_reference_id=${encodeURIComponent(userID)}`;

    //Test Stripe links
    const testBasicStripeLink = "https://buy.stripe.com/test_6oE6sedXr2MV3q83cc"; 
    const testBasicStripeLinkWithUser = `https://buy.stripe.com/test_6oE6sedXr2MV3q83cc?client_reference_id=${encodeURIComponent(userID)}`;

    return (
        <div className='membership_page'>
            <div className='membership_header'>
                <h1>Membership Tiers</h1>
            </div>

            <div className='membership_container'>

                    {/*Premium Tier*/}
                    <div className='membership' id="premium">
                        <h2 className='membership_header' id='premium_membership_headers'>Premium</h2>
                        <ul className='membership_list'>
                            <li>Priority support</li>
                            <li>100 messages per minute</li>
                            <li>Generate 100 pictures per minute</li>
                            <li>Able to generate 3 image per minute</li>
                            <li>Access to video generation</li>
                            <li>Even longer short term memory</li>
                            <li>Extreme long term memory</li>
                            <li>Access to features from basic tier</li>
                            <li>Create custom personalities</li>
                        </ul>
                        <a href={premiumStripeLink}>
                            <button className='membership_button' id='premium_membership_button'>Join Premium</button>
                        </a>
                    </div>

                    {/*Basic Tier*/}               
                    <div className='membership' id="basic">
                        <h2 className='membership_header' id='basic_membership_headers'>Basic</h2>
                        <ul className='membership_list'>
                            <li>50 messages per minute</li>
                            <li>Generate 50 pictures per minute</li>
                            <li>Able to generate 1 image per minute</li>
                            <li>Priority Support</li>
                            <li>Longer short term bot memory (last 10 messages)</li>
                            <li>Able to recall more long term memories</li>
                            <li>Choose from more diffrent personalities</li>
                            <li>Access to features from free tier</li>
                        </ul>
                        <a href={testBasicStripeLinkWithUser}>
                            <button className='membership_button' id='basic_membership_button'>Join Basic</button>          
                        </a>
                    </div>
 m,',]=-3'
                    {/*Server Tier*/}
                    <div className='membership' id="server">
                        <h2 className='membership_header' id="server_membership_headers">Server</h2>
                        <ul className='membership_list'>
                            <li>Usable by all server users</li>
                            <li>Access to features from basic tier</li>
                            <li>Priority support</li>
                            <li>50 messages per minute per user</li>
                            <li>Generate 25 pictures per minute per user</li>
                            <li>Able to generate 1 image per minute for each user</li>
                            <li>Even longer short term memory</li>
                            <li>Extreme long term memory</li>
                            <li>Create custom personalities</li>
                        </ul>
                        <a href={serverStripeLink}>
                            <button className='membership_button' id='server_membership_button'> Join Server Premium</button>
                        </a>
                    </div>
            </div>
            <p>BogAi is still undergoing active development and tuning, while I wil try to avoid price changes the may be necicary to cover operating costs.<br></br>I thank you for your understanding</p>
        </div>
    );
};

export default Membership;